import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import Arrow from "Images/profile/rightArrow.svg";
import styles from "./styles.module.scss";
export function NextRoundedArrow(props) {
    const { onClick } = props;
    return (_jsx("div", { role: "button", tabIndex: 0, onKeyDown: () => null, className: `${styles.rounded_arrow} ${styles.next_arr}`, onClick: onClick, children: _jsx("img", { src: Arrow, alt: "left" }) }));
}
export function PrevRoundedArrow(props) {
    const { onClick } = props;
    return (_jsx("div", { role: "button", onKeyDown: () => null, tabIndex: 0, className: `${styles.rounded_arrow} ${styles.prev_arr}`, onClick: onClick, children: _jsx("img", { src: Arrow, alt: "left" }) }));
}
